import { Title } from "@/components/ui/typography";
import Link from "next/link";
import { ChevronRight } from "lucide-react";
import ProductSlider from "@/components/productSlider";
import Animate from "@/components/Animate";

export default function ProductBanner({
  title,
  productList,
  href = "/products?page=1&categories=all",
}) {
  return (
    <>
      <div className="max-w-[1440px] mx-auto px-3 md:px-6 lg:px-11">
        <Animate animation="fadeInUp" threshold={0.2}>
          <div className="flex items-center justify-between  mb-4">
            <Title size="lg">{title}</Title>

            <Link
              href={href}
              className="text-system-primary  inline-flex items-center p-0 wireless-Medium hoverunderline hoverunderline-blue"
            >
              <span className="hidden md:inline-block  mt-[4px] leading-[120%]">
                See all
              </span>
              <ChevronRight className="h-[20px] w-[20px]  " />
            </Link>
          </div>
        </Animate>
      </div>
      <div className="max-w-[1440px] mx-auto px-3 md:px-6 lg:px-11">
        <ProductSlider productList={productList} />
      </div>
    </>
  );
}
